module.exports = __webpack_public_path__ + "static/media/SUBIR_DATOS.7eb957e6.jpg";